let filterContainer = null;
let filterButtons = null;
let collectionContainer = null;
let headerContainer = null;
let loadingElement = null;

let modalButtons = null;
let closeButtons = null;
let filterValueLinks = null;
let sortOptionLinks = null;
let filterRowLinks = null;
let activeCollectionFetchController = null;

window.collectionHeaderSectionId = document.querySelector(
  '[data-section-type="collection-header"]'
)?.dataset.sectionId;

if (!window.collectionProductsSectionId) {
  window.collectionProductsSectionId = document.querySelector(
    '[data-section-type="collection-products"]'
  )?.dataset.sectionId;
}

const initializeCollectionFilter = () => {
  filterContainer = document.querySelector(".filter-tabs");
  filterButtons = document.querySelectorAll(".filter-button");
  collectionContainer = document.querySelector(
    '[data-section-type="collection-products"]'
  );
  headerContainer = document.querySelector(
    '[data-section-type="collection-header"]'
  );
  loadingElement = document.querySelector(".collection-header-loading");

  filterValueLinks = document.querySelectorAll(
    ".filter-value[data-filter-url]"
  );
  sortOptionLinks = document.querySelectorAll(".sort-option[data-filter-url]");
  filterRowLinks = document.querySelectorAll(
    ".filter-row-value[data-filter-url]"
  );

  if (filterContainer && filterButtons.length > 0) {
    filterButtons.forEach((button) => {
      button.addEventListener("click", handleFilterClick);
    });
  }

  filterValueLinks.forEach((link) => {
    link.addEventListener("click", handleFilterValueClick);
  });

  sortOptionLinks.forEach((link) => {
    link.addEventListener("click", handleSortClick);
  });

  filterRowLinks.forEach((link) => {
    link.addEventListener("click", handleFilterValueClick);
  });

  initializeFilterModal();
};

const initializeFilterModal = () => {
  modalButtons = document.querySelectorAll("[data-open]");
  closeButtons = document.querySelectorAll("[data-close]");

  modalButtons.forEach((button) => {
    button.addEventListener("click", handleModalOpen);
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", handleModalClose);
  });

  document.addEventListener("click", handleModalOutsideClick);

  initializeCollapsibleFilters();
};

const handleModalOpen = (event) => {
  event.preventDefault();
  const button = event.currentTarget;
  const modalId = button.getAttribute("data-open");
  const modal = document.querySelector(`[data-modal="${modalId}"]`);

  const allModals = document.querySelectorAll(".subfilter-modal.open");
  allModals.forEach((openModal) => {
    if (openModal !== modal) {
      openModal.classList.remove("open");
    }
  });

  if (modal) {
    modal.classList.add("open");
  }
};

const handleModalClose = (event) => {
  event.preventDefault();
  const button = event.currentTarget;
  const modalId = button.getAttribute("data-close");
  const modal = document.querySelector(`[data-modal="${modalId}"]`);
  if (modal) {
    modal.classList.remove("open");
  }
};

const handleModalOutsideClick = (event) => {
  const modals = document.querySelectorAll(".subfilter-modal.open");
  modals.forEach((modal) => {
    if (!modal.contains(event.target) && !event.target.closest("[data-open]")) {
      modal.classList.remove("open");
    }
  });
};

const handleFilterValueClick = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const link = event.currentTarget;
  let url = link.dataset.filterUrl;

  // Instantly update active state for immediate visual feedback
  updateFilterValueActiveState(link);

  if (
    link.closest(".filter-category-1") ||
    (link.classList.contains("filter-row-value") &&
      link.href.includes("product_category_1"))
  ) {
    url = ensureSingleCategoryFilter(url);
  }

  if (link.classList.contains("filter-row-value")) {
    url = removePageParameter(url);
    updateFilterRowActiveState(link);
  }

  showLoadingState();

  const isFromModal = link.closest(".subfilter-modal") !== null;

  try {
    await updateCollectionSections(url, isFromModal);
    window.history.pushState({}, "", url);
    hideLoadingState();
  } catch (error) {
    if (error?.name === "AbortError") {
      // Superseded — the newer click's own success path owns cleanup.
      return;
    }
    console.error("Error filtering products:", error);
    hideLoadingState();
    window.location.href = url;
  }
};

const handleSortClick = async (event) => {
  event.preventDefault();

  const link = event.currentTarget;
  const baseSortUrl = link.dataset.filterUrl;

  const currentUrl = new URL(window.location);
  const sortUrl = new URL(baseSortUrl, window.location.origin);

  // Use append instead of set to preserve multiple values for the same key
  for (const [key, value] of currentUrl.searchParams) {
    if (key.startsWith("filter.")) {
      sortUrl.searchParams.append(key, value);
    }
  }

  const url = sortUrl.toString();

  showLoadingState();

  try {
    await updateCollectionSections(url);
    window.history.pushState({}, "", url);
    hideLoadingState();

    const sortModal = document.querySelector('[data-modal="sorting-modal"]');
    if (sortModal) {
      sortModal.classList.remove("open");
    }
  } catch (error) {
    if (error?.name === "AbortError") {
      return;
    }
    console.error("Error sorting products:", error);
    hideLoadingState();
    window.location.href = url;
  }
};

const updateCollectionSections = async (url, keepModalOpen = false) => {
  if (
    !window.collectionProductsSectionId ||
    !window.collectionHeaderSectionId
  ) {
    throw new Error("Section IDs not found");
  }

  const isModalOpen = keepModalOpen
    ? document.querySelector(".subfilter-modal.open")
    : null;
  const openModalId = isModalOpen
    ? isModalOpen.getAttribute("data-modal")
    : null;

  const expandedFilters = [];
  const filterOptions = document.querySelectorAll(".filter-option.expanded");
  filterOptions.forEach((option) => {
    const filterText = option.textContent.trim().split("\n")[0].trim();

    let nextElement = option.nextElementSibling;
    while (nextElement && !nextElement.classList.contains("filter-values")) {
      nextElement = nextElement.nextElementSibling;
    }

    const height = nextElement ? nextElement.scrollHeight + 12 : 0;

    expandedFilters.push({
      text: filterText,
      height: height,
    });
  });

  const sectionUrl = new URL(url, window.location.origin);
  sectionUrl.searchParams.set(
    "sections",
    `${window.collectionProductsSectionId},${window.collectionHeaderSectionId}`
  );

  // Cancel any in-flight request so a rapid second click always wins.
  activeCollectionFetchController?.abort();
  const controller = new AbortController();
  activeCollectionFetchController = controller;

  const response = await fetch(sectionUrl, { signal: controller.signal });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  if (activeCollectionFetchController === controller) {
    activeCollectionFetchController = null;
  }

  const data = await response.json();

  if (data[window.collectionProductsSectionId] && collectionContainer) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = data[window.collectionProductsSectionId];

    const newSection = tempDiv.querySelector(
      '[data-section-type="collection-products"]'
    );
    if (newSection) {
      collectionContainer.outerHTML = newSection.outerHTML;

      collectionContainer = document.querySelector(
        '[data-section-type="collection-products"]'
      );

      initializeCollectionPagination();
      initializePaginationLinks();
      initializeProductCards();
      if (typeof initNotifyMeModal === "function") {
        initNotifyMeModal();
      }
      if (typeof window.initializeLazyVideos === "function") {
        window.initializeLazyVideos(collectionContainer);
      }
    }
  }

  if (data[window.collectionHeaderSectionId] && headerContainer) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = data[window.collectionHeaderSectionId];

    const newHeader = tempDiv.querySelector(
      '[data-section-type="collection-header"]'
    );
    if (newHeader) {
      headerContainer.outerHTML = newHeader.outerHTML;

      headerContainer = document.querySelector(
        '[data-section-type="collection-header"]'
      );

      initializeCollectionFilter();

      if (openModalId) {
        const modal = document.querySelector(`[data-modal="${openModalId}"]`);
        if (modal) {
          modal.classList.add("open");

          // Temporarily disable transitions to prevent animation
          modal.style.transition = "none";
          const allFilterValues = modal.querySelectorAll(".filter-values");
          allFilterValues.forEach((el) => {
            el.style.transition = "none";
          });

          expandedFilters.forEach((filterData) => {
            const filterOptions = modal.querySelectorAll(".filter-option");
            filterOptions.forEach((option) => {
              const optionText = option.textContent
                .trim()
                .split("\n")[0]
                .trim();
              if (optionText === filterData.text) {
                option.classList.add("expanded");
                option.setAttribute("aria-expanded", "true");

                let nextElement = option.nextElementSibling;
                while (
                  nextElement &&
                  !nextElement.classList.contains("filter-values")
                ) {
                  nextElement = nextElement.nextElementSibling;
                }

                if (nextElement) {
                  nextElement.classList.add("expanded");
                  nextElement.style.maxHeight = `${
                    nextElement.scrollHeight + 12
                  }px`;
                  nextElement.style.overflow = "visible";
                }
              }
            });
          });

          setTimeout(() => {
            modal.style.transition = "";
            allFilterValues.forEach((el) => {
              el.style.transition = "";
            });
          }, 50);
        }
      }
    }
  }
};

const handleFilterClick = async (event) => {
  event.preventDefault();

  const link = event.currentTarget;
  const url = link.dataset.filterUrl;

  updateActiveState(link);

  showLoadingState();

  try {
    await updateCollectionSections(url, false);
    window.history.pushState({}, "", url);
    hideLoadingState();
  } catch (error) {
    if (error?.name === "AbortError") {
      return;
    }
    console.error("Error filtering products:", error);
    hideLoadingState();
    window.location.href = url;
  }
};

const updateActiveState = (activeLink) => {
  filterButtons.forEach((link) => {
    link.classList.remove("active");
  });

  activeLink.classList.add("active");
};

const updateFilterRowActiveState = (clickedLink) => {
  const filterRowContainer = clickedLink.closest(".collection-filter-rows");

  if (filterRowContainer) {
    const allFilterRowValues =
      filterRowContainer.querySelectorAll(".filter-row-value");

    const wasActive = clickedLink.classList.contains("active");

    allFilterRowValues.forEach((link) => {
      link.classList.remove("active");
    });

    if (!wasActive) {
      clickedLink.classList.add("active");
    }
  }
};

const updateFilterValueActiveState = (clickedLink) => {
  if (clickedLink.closest(".subfilter-modal")) {
    const wasActive = clickedLink.classList.contains("active");

    if (clickedLink.closest(".filter-category")) {
      const categoryContainer = clickedLink.closest(".filter-category");
      const allCategoryValues =
        categoryContainer.querySelectorAll(".filter-value");

      if (!wasActive) {
        clickedLink.classList.add("active");
      }
    } else {
      if (wasActive) {
        clickedLink.classList.remove("active");
      } else {
        clickedLink.classList.add("active");
      }
    }

    updateFilterOptionActiveState(clickedLink);
  }
};

const updateFilterOptionActiveState = (filterValueLink) => {
  const filterValuesContainer = filterValueLink.closest(".filter-values");
  if (!filterValuesContainer) return;

  let filterOption = filterValuesContainer.previousElementSibling;
  while (filterOption && !filterOption.classList.contains("filter-option")) {
    filterOption = filterOption.previousElementSibling;
  }

  if (filterOption) {
    const activeValues = filterValuesContainer.querySelectorAll(
      ".filter-value.active"
    );

    if (activeValues.length > 0) {
      filterOption.classList.add("active");
    } else {
      filterOption.classList.remove("active");
    }
  }
};

const ensureSingleCategoryFilter = (url) => {
  const urlObj = new URL(url, window.location.origin);

  const currentUrl = new URL(window.location);

  const paramsToRemove = [];
  for (const [key, value] of currentUrl.searchParams) {
    if (key.includes("filter.p.m.custom.product_category_1")) {
      paramsToRemove.push(key);
    }
  }

  const baseUrl = new URL(window.location);
  paramsToRemove.forEach((param) => baseUrl.searchParams.delete(param));

  for (const [key, value] of urlObj.searchParams) {
    if (key.includes("filter.p.m.custom.product_category_1")) {
      baseUrl.searchParams.set(key, value);
    }
  }

  return baseUrl.toString();
};

const removePageParameter = (url) => {
  const urlObj = new URL(url, window.location.origin);
  urlObj.searchParams.delete("page");
  return urlObj.toString();
};

const showLoadingState = () => {
  if (loadingElement) {
    loadingElement.classList.add("active");
  }

  const allFilterButtons = document.querySelectorAll(
    ".filter-button, .filter-value, .sort-option, .filter-row-value, .filter-option"
  );
  allFilterButtons.forEach((button) => {
    button.style.pointerEvents = "none";
  });

  const modalButtons = document.querySelectorAll("[data-open], [data-close]");
  modalButtons.forEach((button) => {
    button.style.pointerEvents = "none";
  });
};

const hideLoadingState = () => {
  if (loadingElement) {
    loadingElement.classList.remove("active");
  }

  const allFilterButtons = document.querySelectorAll(
    ".filter-button, .filter-value, .sort-option, .filter-row-value, .filter-option"
  );
  allFilterButtons.forEach((button) => {
    button.style.pointerEvents = "";
    button.style.opacity = "";
  });

  const modalButtons = document.querySelectorAll("[data-open], [data-close]");
  modalButtons.forEach((button) => {
    button.style.pointerEvents = "";
    button.style.opacity = "";
  });
};

const initializeCollapsibleFilters = () => {
  const filterOptions = document.querySelectorAll(".filter-option");

  filterOptions.forEach((filterOption) => {
    filterOption.addEventListener("click", handleFilterToggle);
    filterOption.addEventListener("keydown", handleFilterKeydown);
  });

  window.addEventListener(
    "resize",
    debounceFn(recalculateExpandedHeights, 150)
  );
};

const handleFilterKeydown = (event) => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    handleFilterToggle(event);
  }
};

const debounceFn = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const recalculateExpandedHeights = () => {
  const expandedFilters = document.querySelectorAll(".filter-values.expanded");
  expandedFilters.forEach((filterValues) => {
    filterValues.style.maxHeight = `${filterValues.scrollHeight + 12}px`;
  });

  const allFilterValues = document.querySelectorAll(".filter-values");
  allFilterValues.forEach((filterValues) => {
    if (
      filterValues.style.maxHeight &&
      filterValues.style.maxHeight !== "0px"
    ) {
      filterValues.style.maxHeight = `${filterValues.scrollHeight + 12}px`;
    }
  });
};

const handleFilterToggle = (event) => {
  event.preventDefault();

  const filterOption = event.currentTarget;
  const isExpanded = filterOption.classList.contains("expanded");

  let nextElement = filterOption.nextElementSibling;
  while (nextElement && !nextElement.classList.contains("filter-values")) {
    nextElement = nextElement.nextElementSibling;
  }

  const allFilterOptions = document.querySelectorAll(".filter-option");
  const allFilterValues = document.querySelectorAll(".filter-values");

  allFilterOptions.forEach((option) => {
    if (option !== filterOption) {
      option.classList.remove("expanded");
      option.setAttribute("aria-expanded", "false");
    }
  });

  allFilterValues.forEach((filterValues) => {
    if (filterValues !== nextElement) {
      filterValues.classList.remove("expanded");
      filterValues.style.maxHeight = "0";
      filterValues.style.overflow = "hidden";
    }
  });

  if (isExpanded) {
    filterOption.classList.remove("expanded");
    filterOption.setAttribute("aria-expanded", "false");
    if (nextElement) {
      nextElement.classList.remove("expanded");
      nextElement.style.maxHeight = "0";
      nextElement.style.overflow = "hidden";
    }
  } else {
    filterOption.classList.add("expanded");
    filterOption.setAttribute("aria-expanded", "true");

    if (nextElement) {
      nextElement.classList.add("expanded");
      setTimeout(() => {
        nextElement.style.maxHeight = `${nextElement.scrollHeight + 12}px`;
      }, 10);
    }
  }
};

document.addEventListener("DOMContentLoaded", initializeCollectionFilter);
